import { Building2Icon, ExternalLinkIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@/components/ui/button";
import { dates } from "@/lib/dates";
import { CertificationType } from "@/types";

export const Certification = ({
  certification,
}: {
  certification: CertificationType;
}) => {
  const dateDisplay =
    dates.prepareDateDisplayForCertificationOrEducationOrWorkExperience({
      startMonth: certification.startMonth,
      startYear: certification.startYear,
      endMonth: certification.endMonth,
      endYear: certification.endYear,
      current: undefined,
    });

  const name = certification.name?.trim();
  const organization = certification.organization?.trim();

  const dot = <span className="text-slate-500">·</span>;
  const hasCredentialId = !!certification.credentialId;

  return (
    <Row className="items-start gap-4">
      <Row className="h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50">
        <Building2Icon className="h-5 w-5 text-slate-400" />
      </Row>
      <Column className="min-w-0 flex-1 gap-0.5">
        <Row className="flex-wrap items-baseline justify-between gap-x-2">
          <Row className="flex-wrap items-baseline gap-x-2">
            {name ? (
              <Text variant="header">{name}</Text>
            ) : (
              <Text className="italic text-red-400" variant="header">
                [Missing Name]
              </Text>
            )}
            {organization && (
              <>
                {dot}
                <Text className="font-normal text-slate-500">
                  {organization}
                </Text>
              </>
            )}
          </Row>
          {certification.credentialUrl && (
            <Button
              className="text-base font-semibold text-primary-900"
              onClick={() => {
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                window.open(certification.credentialUrl || undefined, "_blank");
              }}
              variant="link"
            >
              <ExternalLinkIcon className="h-4 w-4" />
              View
            </Button>
          )}
        </Row>
        {(dateDisplay || hasCredentialId) && (
          <Row className="flex-wrap items-center gap-x-2 text-sm text-slate-500">
            {dateDisplay && <span>{dateDisplay}</span>}
            {dateDisplay && hasCredentialId && dot}
            {hasCredentialId && <span>ID: {certification.credentialId}</span>}
          </Row>
        )}
      </Column>
    </Row>
  );
};
